import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IS_MESSENGER } from '../config/appVariant';

// The small row of links every site needs: who we are, the rules, and how to get help.

export const SITE_LINKS = [
  { to: '/about', key: 'about', label: 'About', title: 'About Bazzef' },
  { to: '/terms', key: 'terms', label: 'Terms', title: 'Terms of Use' },
  { to: '/privacy', key: 'privacy', label: 'Privacy', title: 'Privacy Policy' },
  { to: '/guidelines', key: 'guidelines', label: 'Guidelines', title: 'Community Guidelines' },
  { to: '/support', key: 'support', label: 'Support', title: 'Support' },
  { to: '/contact', key: 'contact', label: 'Contact', title: 'Contact us' },
];

const SiteLinks = ({ className = '', onNavigate }) => {
  const { t } = useTranslation();
  return (
    <nav aria-label={t('site.linksLabel', 'About and legal')} className={`flex flex-wrap gap-x-3 gap-y-1 text-xs ${className}`}>
      {(IS_MESSENGER ? SITE_LINKS.filter((link) => link.key === 'terms' || link.key === 'privacy') : SITE_LINKS).map((link) => (
        <Link
          key={link.to}
          to={link.to}
          onClick={onNavigate}
          className="font-normal text-zinc-500 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-100 hover:underline"
        >
          {t(`site.${link.key}`, link.label)}
        </Link>
      ))}
      <span className="text-zinc-400 dark:text-zinc-500">© {new Date().getFullYear()} Bazzef</span>
    </nav>
  );
};

export default SiteLinks;
